
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { SlTypographyComponent } from '../sl-typography/sl-typography.component';
import {
  CheckboxInput,
  CheckboxOutput,
} from './interfaces/sl-checkbox-interfaces';

@Component({
  selector: 'sl-checkbox-menu-item',
  standalone: true,
  imports: [SlTypographyComponent],
  templateUrl: './sl-checkbox-menu-item.component.html',
  styleUrl: './sl-checkbox-menu-item.component.scss',
})
export class SlCheckboxMenuItemComponent {
  @Input() id!: string;
  @Input() items: CheckboxInput[] = [];

  @Output() selectionChange: EventEmitter<CheckboxOutput[]> = new EventEmitter<
    CheckboxOutput[]
  >();
  @Output() clickedElementEvent: EventEmitter<HTMLElement | null> =
    new EventEmitter<HTMLElement | null>();

  @ViewChildren('checkboxInput')
  checkboxInputs!: QueryList<ElementRef>;

  itemsList: string[] = [];

  onClickButton(event: MouseEvent, itemName: string, elementIndex: number) {
    event.stopPropagation();
    const item = this.items.find((i) => i.name === itemName);

    if (item) {
      const target = event.target as HTMLElement;
      const checkbox = target.parentElement?.childNodes[
        elementIndex
      ] as HTMLInputElement;
      checkbox.checked = !this.items[elementIndex].value;
      (event.target as HTMLInputElement).checked = checkbox.checked;
    }

    this.selectionChange.emit(this.filterSelected(itemName, event));
    this.clickedElementEvent.emit(event.target as HTMLElement);
  }

  onClickCheckbox(event: MouseEvent, itemName: string) {
    event.stopPropagation();
    this.selectionChange.emit(this.filterSelected(itemName, event));

    this.clickedElementEvent.emit((event.target as HTMLElement)?.parentElement);
  }

  filterSelected(itemName: string, event: MouseEvent): CheckboxOutput[] {
    return this.items.map((item) => {
      if (item.name === itemName) {
        item.value = (event.target as HTMLInputElement).checked;
      }
      return {
        name: item.name,
        value: item.value ?? false,
      };
    });
  }
}
